import type { ListOption } from './list-sidebar';

import type { ImportMode, ImportedOption } from '../integrations-types';

export const mergeImportedOptions = ({
  current,
  imported,
  mode,
  makeShortId,
}: {
  current: ListOption[];
  imported: ImportedOption[];
  mode: ImportMode;
  makeShortId: () => string;
}): ListOption[] => {
  if (mode === 'add') {
    const currentValues = new Set(current.map((option) => option.value));
    return [
      ...current,
      ...imported
        .filter((option) => !currentValues.has(option.value))
        .map((option) => ({ label: option.label, value: option.value, shortId: makeShortId() })),
    ];
  }

  const currentByValue = new Map(current.map((option) => [option.value, option]));
  return imported.map((option) => {
    const existing = currentByValue.get(option.value);
    return {
      shortId: existing ? existing.shortId : makeShortId(),
      label: option.label,
      value: option.value,
    };
  });
};
